import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { DMSv3SettingsDashboardQueryKeys } from "modules/DMSv3/Settings/queryKeys";
import { ApiInstance } from "utils/Api";

import type { AddEditLocationFormPayload } from "modules/DMSv3/Settings/components/AddEditLocationModal";

export const useCreateLocationMutation = () =>
  useTypedMutation<AddEditLocationFormPayload, void>({
    mutationFn: async payload => (await ApiInstance.post(`/config/location/update`, payload, ENV.dmsv3BaseURL)).data,
    onSuccess: () => typedQueryClient.invalidateQueries(DMSv3SettingsDashboardQueryKeys.dealers)
  });
